export default {
  props: {
    /**
     * The value we are two way binding with this table using v-model. Returns a list of selected items
     */
    modelValue: {
      type: Array,
      default() {
        return []
      }
    },

    /**
     * A list of field headers we want to display at the top of the table
     */
    headers: {
      type: Array,
      default() {
        return []
      }
    },

    /**
     * If true we display the "select all" checkbox
     */
    selectable: {
      type: Boolean,
      default: true
    },

    /**
     * An array of strings indicating actions that can be performed on an item that belongs to this table. Actions
     * might include things like edit, delete, or update, but can be whatever you want.
     * Example: To add an action
     * pass a string to this prop like this :actions="['edit', 'update', 'promote']"
     * All strings should be lowercase.
     *
     * This list should include ALL actions that can be performed in this table, even if some items shouldn't do
     * that action. If you want to prevent certain actions from being performed on some items, you can do so
     * using the :can="[]" prop on the Row component you pass to this table using the rows slot
     */
    actions: {
      type: Array,
      default() {
        return []
      }
    }
  }
}
